module.exports = __webpack_public_path__ + "img/Google_Play_2015.6ebbcbac.png";